import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import api from "~/lib/api";
import { useTranslation } from "react-i18next";
import { handleError } from "~/lib/helpers";
import { Button, Text } from "~/components-shared";
import Picture from "~/components-shared/Picture";
import ai from "~/assets/i/logos/ai.png";
import { AIGenerateTargetEnum } from "~/types/enums";
import styled from "styled-components";
const StyledPicture = styled(Picture)`
  display: inline-block;
  vertical-align: top;
`;
const pickTargetMethod = (target, value) => {
  switch (target) {
    case AIGenerateTargetEnum.REQUEST_COMMENT:
      return api.aiGenerateImage(value, "512x512", 1);
    case AIGenerateTargetEnum.NAME_PRONUNCIATION:
      return api.aiGenerateNamePronunciation(value);
    case AIGenerateTargetEnum.COMPANY_DESCRIPTION:
      return api.aiGenerateCompanyDescription(value);
    case AIGenerateTargetEnum.COMMUNITY_SUMMARY:
      return api.aiGenerateCommunitySummary(value);
    case AIGenerateTargetEnum.COMMUNITY_IMAGE:
      return api.aiGenerateCommunityImage(value);
    default:
      return api.aiGenerateCommunitySummary(value);
  }
};
const AiGenerateButton = _ref => {
  let {
    target,
    value,
    noLabel = false,
    noValueError = "No generation value provided",
    onGenerateStarted,
    onGenerateSucceeded,
    onGenerateFailed,
    onError,
    children,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const generateSummary = () => {
    if (!value) {
      if (typeof onGenerateFailed === "function") {
        onGenerateFailed(noValueError);
      }
      return;
    }
    if (typeof onGenerateStarted === "function") {
      onGenerateStarted();
    }
    setIsLoading(true);
    pickTargetMethod(target, value).then(result => {
      if (typeof onGenerateSucceeded === "function") {
        onGenerateSucceeded(result);
      }
    }).catch(error => {
      if (typeof onGenerateFailed === "function") {
        onGenerateFailed(handleError(error));
      }
    }).finally(() => {
      setIsLoading(false);
    });
  };
  return /*#__PURE__*/React.createElement(Button, _extends({
    s: noLabel ? {
      p: 1
    } : {
      pl: 1.5,
      pr: 3,
      py: 1
    },
    color: "ai",
    elemBefore: /*#__PURE__*/React.createElement(StyledPicture, {
      src: ai,
      width: "1.3rem",
      height: "1.3rem"
    }),
    fontSize: 3,
    onClick: generateSummary,
    rounded: true,
    loading: isLoading
  }, rest), !noLabel && /*#__PURE__*/React.createElement(Text, {
    s: {
      ml: 1
    }
  }, children || t("common.actions.generate")));
};
export default AiGenerateButton;